export const NiveauPermission = ['Lecture', 'Ecriture', 'Aucun'] as const
export type NiveauPermission = typeof NiveauPermission[number]

export const NiveauPermissionLibelle: Record<NiveauPermission, string> = {
  Aucun: "Aucun",
  Ecriture: "Écriture",
  Lecture: "Lecture"
} as const
